/** Saves Accounts Balances
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCES = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** Saves Schedule Types
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfersscheduleTypes
*/
export const SAVE_SCHEDULE_TYPES = (state, payload) => {
    state.scheduleTypes = payload
}

/** Saves Transfers Categories List
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transferscategories
*/
export const SAVE_TRANSFERS_CATEGORIES_LIST = (state, payload) => {
    state.transfersCategoriesList = payload
}

/** Saves Transfers Motives List
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transferscategories%7Bcid%7Dmotives
*/
export const SAVE_TRANSFERS_MOTIVES_LIST = (state, payload) => {
    state.transfersMotivesList = payload
}

/** saves the transfers list
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operations
*/
export const TRANSFERS_OPERATIONS_LIST = (state, data) => {
    state.transfersOperationsList = data.customerOperations
}

/** saves the transfers list
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfers
*/
export const SAVE_TRANSFERS_LIST = (state, data) => {
    state.transfersList = data.transfers
}

/** saves Smart Transfers List
@payload { Array } Sem Documentação
*/
export const SAVE_SMART_TRANSFERS_LIST = (state, data) => {
    state.smartTransfersList = data.submissions
}

/** saves the favorites list
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_favoriteslist
*/
export const SAVE_FAVORITES_LIST = (state, { pageNumber, data }) => {
    state.favoritesList = pageNumber === 1 ? data.favorites : state.favoritesList.concat(data.favorites)

    state.favoritesHasMore = state.favoritesList.length < data.total
}

/** saves beneficiaries list
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfersbeneficiaries
*/
export const SAVE_BENEFICIARIES_LIST = (state, payload) => {
    state.beneficiariesList = payload
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.accountsBalances = []
    state.scheduleTypes = []
    state.transfersCategoriesList = []
    state.transfersList = []
    state.smartTransfersList = []
    state.favoritesList = []
    state.favoritesHasMore = null
    state.beneficiariesList = []
}
